import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static values = {
        debounceDelay: { type: Number, default: 150 },
    }

    connect() {
        this.timeout = null
    }

    disconnect() {
        if (this.timeout) {
            clearTimeout(this.timeout)
        }
    }

    search(event) {
        const query = event.detail.query

        // Clear existing timeout
        if (this.timeout) {
            clearTimeout(this.timeout)
        }

        // Debounce the search
        this.timeout = setTimeout(() => {
            this.performSearch(query)
        }, this.debounceDelayValue)
    }

    performSearch(query) {
        // Use mobile list endpoint for native apps, regular messenger for desktop
        const isNativeApp = document.body.classList.contains('native-app')
        const basePath = isNativeApp ? '/messenger/list' : '/messenger'
        const url = new URL(window.location.origin + basePath)

        if (query && query.trim().length > 0) {
            url.searchParams.set('query', query.trim())
        }

        // Preserve current chat if one is selected (desktop only)
        if (!isNativeApp) {
            const currentChatId = new URLSearchParams(window.location.search).get('id')
            if (currentChatId) {
                url.searchParams.set('id', currentChatId)
            }
        }

        Turbo.visit(url.toString(), { action: 'replace', frame: 'chat-list-results' })
    }
}
